const data = {
  piuTariffeOptions: [
    { code: "2.1", description: "Sì" },
    { code: "2.2", description: "No" },
  ],
  compagniaOptions: [
    { code: "1.00091", description: "Aviva Life S.p.A." },
    { code: "1.00108", description: "Europ Assistance S.p.A." },
    { code: "1.00141", description: "GenertelLife S.p.A." },
    { code: "1.00111", description: "Global Assistance - S.p.A." },
    { code: "1.00027", description: "Zurich Investments Life S.p.A." },
    { code: "1.00109", description: "MetLife S.p.A." },
    { code: "1.00136", description: "Net Insurance S.p.A." },
    { code: "0.00000", description: "Demo Insurance S.p.A." },
  ],
  canaleOptions: [
    { code: "5.1", description: "Banca" },
    { code: "5.2", description: "Consulenti Finanziari" },
    { code: "5.3", description: "Agenti" },
    { code: "5.4", description: "Broker" },
    { code: "5.5", description: "Diretto" },
    { code: "5.6", description: "Ente Finanziario" },
  ],
  distributoriOptions: [
    { code: "10537050964", description: "Banco BPM" },
    { code: "00043260140", description: "Credito Valtellinese" },
  ],
  modDistribuzioneOptions: [
    { code: "7.1", description: "Fisica" },
    { code: "7.2", description: "Online" },
    { code: "7.3", description: "Telemarketing" },
  ],
  mercatoOptions: [
    { code: "8.1", description: "Retail" },
    { code: "8.2", description: "Business" },
  ],
  ramoOptions: [
    { code: "13.1", description: "Vita" },
    { code: "13.2", description: "Danni" },
  ],
  tipologiaGaranzieOptions: [
    { code: "14.1", description: "CPI Mutui" },
    { code: "14.2", description: "CPI Prestiti" },
    { code: "14.3", description: "CPI Leasing" },
    { code: "14.4", description: "CPI Fidi" },
    { code: "14.5", description: "PPI/Income Protection" },
    { code: "14.6", description: "Protezione correntisti" },
  ],
  prodCommercioOptions: [
    { code: "16.1", description: "Sì" },
    { code: "16.2", description: "No" },
  ],
  tipologiaAssicurazioneOptions: [
    { code: "20.1", description: "Individuale" },
    { code: "20.2", description: "Collettiva" },
  ],
  premioTipologiaOptions: [
    { code: "21.1", description: "Annuo" },
    { code: "21.2", description: "Mensile" },
    { code: "21.3", description: "Unico" },
  ],
  frazPremioOptions: [
    { code: "23.1", description: "Mensile" },
    { code: "23.2", description: "Bimestrale" },
    { code: "23.3", description: "Trimestrale" },
    { code: "23.4", description: "Quadrimestrale" },
    { code: "23.5", description: "Semestrale" },
    { code: "23.6", description: "Non previsto" },
  ],
  rischiAssicuratiRamoVitaOptions: [
    { code: "28.1", description: "Decesso (qualsiasi causa)" },
    { code: "28.2", description: "Decesso da infortunio" },
    { code: "28.3", description: "Decesso da malattia" },
    { code: "28.4", description: "Invalidità Permanente (qualsiasi causa)" },
    { code: "28.5", description: "Invalidità Permanente da infortunio" },
    { code: "28.6", description: "Invalidità Permanente da malattia" },
    { code: "28.7", description: "Inabilità Temporanea (qualsiasi causa)" },
    { code: "28.8", description: "Inabilità Temporanea da infortunio" },
    { code: "28.9", description: "Inabilità Temporanea da malattia" },
    { code: "28.10", description: "Malattie gravi" },
    { code: "28.11", description: "Ricovero ospedaliero" },
    { code: "28.12", description: "Ricovero per Grande Intervento Chirurgico" },
    { code: "28.13", description: "Perdita d'impiego" },
    { code: "28.14", description: "Altri rischi" },
  ],
  rischiAssicuratiRamoDanniOptions: [
    { code: "29.1", description: "Decesso (qualsiasi causa)" },
    { code: "29.2", description: "Decesso da infortunio" },
    { code: "29.3", description: "Decesso da malattia" },
    { code: "29.4", description: "Invalidità Permanente (qualsiasi causa)" },
    { code: "29.5", description: "Invalidità Permanente da infortunio" },
    { code: "29.6", description: "Invalidità Permanente da malattia" },
    { code: "29.7", description: "Inabilità Temporanea (qualsiasi causa)" },
    { code: "29.8", description: "Inabilità Temporanea da infortunio" },
    { code: "29.9", description: "Inabilità Temporanea da malattia" },
    { code: "29.10", description: "Malattie gravi" },
    { code: "29.11", description: "Ricovero ospedaliero" },
    { code: "29.12", description: "Ricovero per Grande Intervento Chirurgico" },
    { code: "29.13", description: "Perdita d'impiego" },
    { code: "29.14", description: "Altri rischi" },
  ],
  decessoQualsiasiCausaOptions: [
    { code: "30.1", description: "Garanzia obbligatoria" },
    { code: "30.2", description: "Garanzia facoltativa" },
  ],
  decessoDaInfortunioOptions: [
    { code: "32.1", description: "Garanzia obbligatoria" },
    { code: "32.2", description: "Garanzia facoltativa" },
  ],
  decessoDaMalattiaOptions: [
    { code: "34.1", description: "Garanzia obbligatoria" },
    { code: "34.2", description: "Garanzia facoltativa" },
  ],
  invaliditaPermanenteQualsiasiCausaOptions: [
    { code: "36.1", description: "Garanzia obbligatoria" },
    { code: "36.2", description: "Garanzia facoltativa" },
  ],
  invaliditaPermanenteDaInfortunioOptions: [
    { code: "38.1", description: "Garanzia obbligatoria" },
    { code: "38.2", description: "Garanzia facoltativa" },
  ],
  invaliditaPermanenteDaMalattiaOptions: [
    { code: "40.1", description: "Garanzia obbligatoria" },
    { code: "40.2", description: "Garanzia facoltativa" },
  ],
  inabilitaTemporaneaQualsiasiCausaOptions: [
    { code: "42.1", description: "Garanzia obbligatoria" },
    { code: "42.2", description: "Garanzia facoltativa" },
  ],
  inabilitaTemporaneaDaInfortunioOptions: [
    { code: "44.1", description: "Garanzia obbligatoria" },
    { code: "44.2", description: "Garanzia facoltativa" },
  ],
  inabilitaTemporaneaDaMalattiaOptions: [
    { code: "46.1", description: "Garanzia obbligatoria" },
    { code: "46.2", description: "Garanzia facoltativa" },
  ],
  malattieGraviOptions: [
    { code: "48.1", description: "Garanzia obbligatoria" },
    { code: "48.2", description: "Garanzia facoltativa" },
  ],
  ricoveroOspedalieroOptions: [
    { code: "50.1", description: "Garanzia obbligatoria" },
    { code: "50.2", description: "Garanzia facoltativa" },
  ],
  ricoveroGrandeInterventoChirurgicoOptions: [
    { code: "52.1", description: "Garanzia obbligatoria" },
    { code: "52.2", description: "Garanzia facoltativa" },
  ],
  perditaImpiegoOptions: [
    { code: "54.1", description: "Garanzia obbligatoria" },
    { code: "54.2", description: "Garanzia facoltativa" },
  ],
  yesNoOptions: [
    { code: "true", description: "Sì" },
    { code: "false", description: "No" },
  ],
  rischiAssicuratiOptions: [
    { code: ".1", description: "Decesso (qualsiasi causa)" },
    { code: ".2", description: "Decesso da infortunio" },
    { code: ".3", description: "Decesso da malattia" },
    { code: ".4", description: "Invalidità Permanente (qualsiasi causa)" },
    { code: ".5", description: "Invalidità Permanente da infortunio" },
    { code: ".6", description: "Invalidità Permanente da malattia" },
    { code: ".7", description: "Inabilità Temporanea (qualsiasi causa)" },
    { code: ".8", description: "Inabilità Temporanea da infortunio" },
    { code: ".9", description: "Inabilità Temporanea da malattia" },
    { code: ".10", description: "Malattie gravi" },
    { code: ".11", description: "Ricovero ospedaliero" },
    { code: ".12", description: "Ricovero per Grande Intervento Chirurgico" },
    { code: ".13", description: "Perdita d'impiego" },
    { code: ".14", description: "Altri rischi" },
  ],
};

const selectChoices = {
  piuTariffe: { code: "", description: "" },
  compagnia: [], // multiselect
  canale: [], // multiselect
  distributori: [], // multiselect
  modDistribuzione: [], // multiselect
  mercato: [], // multiselect
  ramo: [], // multiselect
  tipologiaGaranzie: [], // multiselect
  prodCommercio: { code: "", description: "" },
  tipologiaAssicurazione: { code: "", description: "" },
  premioTipologia: [], // multiselect
  frazPremio: [], // multiselect
  rischiAssicuratiRamoVita: [], // multiselect
  rischiAssicuratiRamoDanni: [], // multiselect
  decessoQualsiasiCausa: { code: "", description: "" },
  decessoDaInfortunio: { code: "", description: "" },
  decessoDaMalattia: { code: "", description: "" },
  invaliditaPermanenteQualsiasiCausa: { code: "", description: "" },
  invaliditaPermanenteDaInfortunio: { code: "", description: "" },
  invaliditaPermanenteDaMalattia: { code: "", description: "" },
  inabilitaTemporaneaQualsiasiCausa: { code: "", description: "" },
  inabilitaTemporaneaDaInfortunio: { code: "", description: "" },
  inabilitaTemporaneaDaMalattia: { code: "", description: "" },
  malattieGravi: { code: "", description: "" },
  ricoveroOspedaliero: { code: "", description: "" },
  ricoveroGrandeInterventoChirurgico: { code: "", description: "" },
  perditaImpiego: { code: "", description: "" },
};

export { selectChoices };
export default data;
